<div class="clear"></div>
<div class="top-actions" id="top-actions">
    <lms-loco-update-int-usage *ngIf="tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'"></lms-loco-update-int-usage>
    <div class="train-box noselect">
        <!-- <lms-train-svg *ngIf="tab?.subTypeDetail[tab?.subType?.toLowerCase()]?.status === 'loaded'" [trainData]="trainSVG" [screenName]="'Train'"
            [isDefaultTrainIcon]="tab?.subTypeDetail[tab?.subType?.toLowerCase()]?.status === 'loaded'? false : true"></lms-train-svg> -->
        <span class="locoIcon-warning" *ngIf="tab?.subTypeDetail[tab?.subType?.toLowerCase()]?.status === 'loaded'">{{tab?.tabSearchParameter?.searchText}}</span>
        <span class="train-na-icon" *ngIf="tab?.subTypeDetail[tab?.subType?.toLowerCase()]?.status !== 'loaded'">NA</span>
        <!-- <img class="train-na-icon" *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status !== 'loaded'" [src]="trainNaIcon" /> -->
    </div>

    <lms-header-sub-types [subTypes]="subTypes" [tab]="tab" [tabIndex]='tabLevel'></lms-header-sub-types>

    <div class="top-buttons-group">
        <button id="trainDataEditBtn" type="button" class="{{(!(trainEdit?.editDisable) && !editDisable && (user && user.isUserManagerOrDirector)) ? 'p-button-secondary' : 'p-button-disabled'}}"
            tabindex="{{tabLevel + 11}}" (click)="editActionTrigger($event);" disabled="{{(!(trainEdit?.editDisable) && !editDisable && (user && user.isUserManagerOrDirector)) ? '' : 'disabled'}}"> <span class="fa fa-pencil"></span> Edit</button>
        <button type="button" class="{{(!(trainEdit?.cancelDisable) && (user && user.isUserManagerOrDirector))? 'p-button-secondary' : 'p-button-disabled'}}"
            tabindex="{{tabLevel + 13}}" (click)="$event.stopPropagation(); cancelActionTrigger($event);" disabled="{{(!(trainEdit?.cancelDisable) && (user && user.isUserManagerOrDirector)) ? '' : 'disabled'}}"> <span class="fa fa-ban"></span> Cancel</button>
        <button type="submit" id="trainDataSubmitBtn" class="{{(!(trainEdit?.submitDisable) && (user && user.isUserManagerOrDirector)) ? 'p-button-primary' : 'p-button-disabled'}}"
            tabindex="{{tabLevel + 15}}" (click)="$event.stopPropagation(); submitActionTrigger($event);" disabled="{{(!(trainEdit?.submitDisable) && (user && user.isUserManagerOrDirector)) ? '' : 'disabled'}}"> <span class="csx csx-common_trash"></span> Submit</button>
    </div>

    <div class="other-actions">
        <p-splitButton #trainSplitBtn id='trainDataSplitBtn' styleClass="split-button-ui" label="Other Actions" [model]="otherOptions"
            tabindex="{{tabLevel + 17}}" [disabled]="(trainEdit?.otherActionDisable) || (user && !user.isUserManagerOrDirector)" (onDropdownClick)="checkForContextMenuVisiblity($event)">
        </p-splitButton>
    </div>

</div>

<div class="clear"></div>

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="addTrainDialog" [resizable]="false" [draggable]="false" class="{{(addTrainHeader === 'Add Train') ? 'terminal-ui-popups' : 'error-dialog terminal-ui-popups'}}"
    header="{{addTrainHeader}}" [(visible)]="addTrainPop" modal="true" closeOnEscape="true" (onHide)='hideDialog("AddTrain");'
    (onShow)='setFocusToFirstElement("addTrainInput", "addTrainDialog");'>
    <lms-message [target]='"popUp"'></lms-message>
    <form #addTrain="ngForm" novalidate (ngSubmit)="addTrainData(addTrain.value)" *ngIf='addTrainPop'>
        <div class="add-train">
            <label>Train ID: </label>
            <input id="addTrainInput" tabindex="{{tabLevelDialog}}" class="{{isAddTrainError ? 'p-inputfield p-inputfield-error train-placeholder' : 'p-inputfield train-placeholder'}}"
                autocomplete="off" type="text" spellcheck="false" name="trainID" #trainID ngModel required minlength="6" placeholder="Train ID"
                maxlength="6"><br>
            <div class="clear"></div>
            <div class="color-red" *ngIf='isAddTrainError' style="padding-left: 35px;">{{configData.messages.planInvalidTrainId}}</div>
            <!--<div class="add-train-on">
					<p>on<br><br><strong>WAYCRO</strong><br>Waycross, GA</p>
				</div>-->
        </div>
        <div class="dialog-buttons">
            <span class="pull-right">
			<button type="button" tabindex="{{tabLevelDialog + 1}}" class="p-button-secondary" (click)='hideDialog("AddTrain");' >Cancel</button>
			<button type="submit" tabindex="{{tabLevelDialog + 2}}" id="addTrainSubmitBtn" class="{{trainID.value.length > 0 ? 'p-button-primary' : 'p-button-disabled'}}"
				disabled="{{trainID.value.length > 0 ? '' : 'disabled'}}">Add</button>
		</span>
        </div>
    </form>
</p-dialog>

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="trainDialogConfrimPop" [resizable]="false" [draggable]="false" class="{{!(confirmHeaderError) ? 'terminal-ui-popups standard-dialog' : 'error-dialog terminal-ui-popups standard-dialog'}}"
    header="{{confirmHeaderError ? confirmHeaderError : confirmAction}}" [(visible)]="confirmPop" modal="true" closeOnEscape="true"
    (onHide)='hideDialog(confirmAction);' (onShow)='setFocusToFirstElement("confirmTrainBtn", "trainDialogConfrimPop");'>
    <div class="generic-spacing text-center">

        <p>{{confirmMessage}}</p><br>
        <div class="train-to-complete-icon" *ngIf="confirmAction === 'Cancel Train' || confirmAction === 'Complete Train'">
            <!--Train SVG here...-->
            <!--<lms-train-svg *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'" [trainData]="trainSVG" [screenName]="'Train'" [isDefaultTrainIcon]="tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'? false : true"></lms-train-svg>-->
            <span class="loco-tag" style="float: none;">{{trainSVG.trainIdentifier}}</span>
        </div>

    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
		<button type="button"  id="cancelCompleteNoButton" tabindex="{{tabLevelDialog}}" class="p-button-secondary" (click)='hideDialog(confirmAction);'>No</button>
		<button type="submit" tabindex="{{tabLevelDialog + 1}}"  id="confirmTrainBtn" disabled="{{disableCancelComplete?'disable':''}}" class="{{disableCancelComplete?'p-button-disabled':'p-button-primary'}}" (click)='confirmbtnAction(confirmAction)'>Yes</button>
	</span>
    </div>
</p-dialog>

<!-- START Plan Locomotive Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="trainDataPlanLocoDialog" [resizable]="false" [draggable]="false" class="{{errorDialog? 'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}"
    header="{{popUpHeaderMessage}}" [(visible)]="planLocomotive" modal="true" (onHide)='resetPageMode();' (onShow)='setPageMode("trainPlanLocoSubBtn"); setFocusToGivenElement("trainDataPlanLocoTrainbox");'>
    <div *ngIf='planLocomotive'>
        <div class="plan-to">
            <div class="plan-to-dropdown">
                <label>{{configData && configData.yardLocalLabel.planTo}}</label>
                <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left" [tabindex]="tabLevelDialog" [options]="planOptions" (onChange)="changePlanOptions('Plan Locomotive')"
                    [(ngModel)]='locoPlannedTo' id='planLocoOptions'></p-dropdown>
            </div>

            <div class="plan-to-input" *ngIf="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.train}}</label>
                <span class="select-train-terminal">
				<input id="trainDataPlanLocoTrainbox" type="text" tabindex="{{tabLevelDialog+1}}" placeholder="Train ID" spellcheck="false"  class="{{isAddTrainError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}"  name="planTrainId" [(ngModel)]="planTrainId" required minlength="6" maxlength="6">
				<div class="color-red" *ngIf='isAddTrainError'>{{configData && configData.messages.planInvalidTrainId}}</div>
				</span>
            </div>

            <div class="plan-to-input" [hidden]="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.terminal}}</label>
                <span class="select-train-terminal">
					<lms-autocomplete spellcheck="false" [tabindex]='tabLevelDialog + 1' styleclass="p-autocomplete" [inputId]='"trainDataPlanLocoFrgnInp"' [(ngModel)]="searchPlanTextTerminal" [ngClass]="'terminal-autocomplete'" placeholder="Mnemonic" [suggestions]="filteredResults"
                        (completeMethod)="autoCompleteForTerminal($event)" [minLength]="2" inputStyleClass="{{searchPlanTextTerminalError ? 'p-inputfield-error' : ''}}" (onSelect)="selectValueFromAutoComplete(searchPlanTextTerminal,'terminalPlanSuggestSearch', 'foreignRailRoad')"
                        [maxlength]="6" (keydown.space)='$event.stopPropagation();' (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'></lms-autocomplete>
                        <font class="update-terminal-text" *ngIf="locoPlannedTo ==='terminal'"> Enter terminal.  Press TAB to evaluate servicing capability.</font>
<div class="color-red" *ngIf='searchPlanTextTerminalError'> {{configData && configData.messages.planInvalidTerminal}} </div>		
				</span>
            </div>

            <div class="plan-to-input frr-road" [hidden]="locoPlannedTo !=='foreignRailRoad'">
                <label>Road</label>
                <span class="select-train-terminal">
				<p-dropdown [panelStyleClass]="'dialog-dropdown'" [filter]="true" [options]="selectedRoadValues" [tabindex]="tabLevelDialog+2" disabled="{{!selectedTerminalRoad}}" styleClass="{{selectedTerminalRoadError ? 'p-inputfield-error pull-left p-dropdown' : 'pull-left p-dropdown'}}" ngModel name='roadValue' [(ngModel)]='selectedTerminalRoad'
                (onChange)='updateErrorValueForRoad();'>
					<ng-template let-roadValue pTemplate="roadValue">
						<div class="p-helper-clearfix">
						<div> {{roadValue.label}} </div>
						</div>
				</ng-template>
				</p-dropdown>
				<div class="color-red" *ngIf='selectedTerminalRoadError'> {{configData.messages.planInvalidRoad}} </div>
				</span>

            </div>

            <div class="terminal-handling-plan" [hidden]="locoPlannedTo === 'foreignRailRoad'">
                <h2>{{configData && configData.yardLocalLabel.terminalHandlingPlan}}</h2>
                <ul>
                    <li *ngIf="!isValidThpSelection">
                        <p-radioButton [tabindex]="tabLevelDialog+3" name="radioButtonPlanLoco" value="S" label="{{configData && configData.yardLocalLabel.serviceCtrShop}}"
                            [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="tabLevelDialog+4" name="radioButtonPlanLoco" value="T" label="{{configData && configData.yardLocalLabel.truckFueling}}"
                            [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="tabLevelDialog+5" name="radioButtonPlanLoco" value="M" label="{{configData && configData.yardLocalLabel.mainTrack}}"
                            [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li *ngIf="user && user.isUserManagerOrDirector">
                        <p-radioButton [tabindex]="tabLevelDialog+6" name="radioButtonPlanLoco" value="X" label="{{configData && configData.yardLocalLabel.toStorage}}"
                            [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                </ul>
                <div>

                </div>
            </div>
            <div class="clear"></div>
        </div>

        <div class="items-to-plan" *ngIf="locoPlannedTo !=='train' && intendedTrainEdit">
            <h2>{{configData && configData.yardLocalLabel.locomotives}} ({{intendedTrainEdit && intendedTrainEdit.selectedLocomotives && intendedTrainEdit.selectedLocomotives.length}})</h2>
            <ul>
                <li *ngFor="let loco of intendedTrainEdit.selectedLocomotives">
                    {{getLocomotiveId(loco?.locomotiveIdentifier)}}
                </li>
            </ul>
        </div>
        <div class="items-to-plan" *ngIf="locoPlannedTo ==='train'">

            <div class="plan-loco-table">
                <div class="table">
                    <div class="table-header">
                        <div class="columns-loco">{{configData && configData.yardLocalLabel.locomotive}} ({{intendedTrainEdit && intendedTrainEdit.selectedLocomotives
                            && intendedTrainEdit.selectedLocomotives.length}})</div>
                        <div class="columns-iu">{{configData && configData.yardLocalLabel.intendedUsage}} </div>
                        <div class="columns-reason">{{configData && configData.yardLocalLabel.reason}} </div>
                        <div class="columns-notes"> </div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" *ngFor="let loco of intendedTrainEdit.selectedLocomotives; let i = index">
                            <lms-intended-usage [tabLevel]='tabLevelDialog + 10 + (i*5)' [locoData]='loco' [indexPosition]='i'></lms-intended-usage>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="dialog-buttons">

            <span class="pull-right">

	<button class="p-button-secondary" tabindex='{{tabLevelDialog+101}}' (click)="hideDialog('PlanLocomotive');" >{{configData && configData.yardLocalLabel.cancel}}</button>

			<button class="p-button-primary" id="trainPlanLocoSubBtn" tabindex="{{tabLevelDialog+102}}" (click)="planLocomotiveSubmit()">{{configData && configData.yardLocalLabel.submit}}</button>
			</span>
        </div>
    </div>
</p-dialog>
<!-- END Plan Locomotive Popup -->


<!-- Start Rule Exception Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="trainDataRuleExcpDialog" [resizable]="false" [draggable]="false" class="terminal-ui-popups rule-exceptions"
    header="Rules Warning" [(visible)]="ruleException" modal="true" (onHide)="cancelOperation('ruleException')">
    <div *ngIf='ruleException'>
        <div class="bre-dialog-header">
            <div class="plan-to-dropdown">
                <label class="pull-left block-32">Plan to Train</label>
                <span class="loco-tag">{{planTrainId ? planTrainId.toUpperCase() : '-'}}</span>
            </div>

        </div>
        <div class="exception-reason">
            <span class="exception-icon"></span>
            <div class="exception-details">
                <span class="color-red">Exception with {{(lmsExceptionList && lmsExceptionList.length > 1) ? lmsExceptionList.length : '' }} Planned {{(lmsExceptionList
			&& lmsExceptionList.length > 1) ? 'Locomotives' : 'Locomotive' }}</span>
                <p class="info-text">To <span>Override Rule</span>,{{(lmsExceptionList && lmsExceptionList.length > 1) ? ' Select Loco and hit
                    submit. Unselected Loco will be auto cancelled.': ' add Reason and hit submit.' }}</p>
            </div>

        </div>
        <div class="exceptions-tbl-head">
            <span class="locomotive-head">LOCOMOTIVE</span>
            <span class="exception-intended-usage-head">INTENDED USAGE INFO</span>
            <span class="exception-info-head">WARNING</span>

        </div>
        <div class="exception-dialog">
            <div class="exception-list">
                <div class="exception-rows" *ngFor='let lException of lmsExceptionList; let i = index'>
                    <lms-bre-exception [tabLevel]='tabLevelDialog + 15' [lmsException]='lException' (checkCheckedLoco)="checkCheckedLoco()"></lms-bre-exception>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
								<button type="button" tabindex="{{tabLevelDialog + 125}}" class="p-button-secondary" (click)="cancelOperation('ruleException')">Cancel</button>
								<button type="button" tabindex="{{tabLevelDialog + 126}}" id='ruleExceptionLocoData' [ngClass]="isRuleExceptionSubmitEnabled? 'p-button-primary' : 'p-button-secondary p-button-disabled'" disabled="{{isRuleExceptionSubmitEnabled? '' : 'disabled'}}" (click)="ruleExceptionSubmit()">Submit</button>
							</span>
    </div>
</p-dialog>
<!-- END Rule Exception Popup -->